<template>
    <div name="review" class="review" id="review">
        <div class="container">
            <div class="section-header">
                <strong class="title">이용 후기</strong>
            </div>
            <ul class="card-list">
                <li>
                    <img class="img-reviewer" src="../../assets/pc_barocare/img_review1.png" alt="이용자 이미지">
                    <div class="cont">
                        <p>어머님 모시고 병원 갈 때마다 연차 쓰고<br>
                            1시간 이상은 병원에서 대기했는데 기다림 없이<br>
                            진료 볼 수 있어서 너무 편합니다.</p>
                        <div class="info-reviewer">
                            <span class="reviewer">보호자</span><strong class="name">김OO님</strong>
                            <span class="info">42, 서울시 강동구</span>
                        </div>
                    </div>
                </li>
                <li>
                    <img class="img-reviewer" src="../../assets/pc_barocare/img_review2.png" alt="이용자 이미지">
                    <div class="cont">
                        <p>원장님을 편하게 자주 보고 진료받을 수 있어서<br>
                            좋습니다. 항상 친절하게 상세하게 물어봐주셔서 무척<br> 감동했어요.</p>
                        <div class="info-reviewer">
                            <span class="reviewer">어르신</span><strong class="name">최OO님</strong>
                            <span class="info">76, 경남 창원시</span>
                        </div>
                    </div>
                </li>
                <li>
                    <img class="img-reviewer" src="../../assets/pc_barocare/img_review3.png" alt="이용자 이미지">
                    <div class="cont">
                        <p>깜깜이 수면제 처방 등이 걱정되었는데,<br>
                            제 카카오톡으로 아버님 처방 내역, 결제 비용, 복약<br>
                            안내까지 실시간 확인되어서 안심이 됩니다.</p>
                        <div class="info-reviewer">
                            <span class="reviewer">보호자</span><strong class="name">송OO님</strong>
                            <span class="info">54, 경기 수원시</span>
                        </div>
                    </div>
                </li>
                <li>
                    <img class="img-reviewer" src="../../assets/pc_barocare/img_review4.png" alt="이용자 이미지">
                    <div class="cont">
                        <p>매번 이전 진료 이후 경과를 꼼꼼히 물어봐 주시고<br>
                            기록을 해주고 계십니다. 자막으로도 진료 내용을<br> 확인할 수 있어 편리합니다.</p>
                        <div class="info-reviewer">
                            <span class="reviewer">어르신</span><strong class="name">김OO님</strong>
                            <span class="info">68, 인천시 미추홀구</span>
                        </div>
                    </div>
                </li>
                <li>
                    <img class="img-reviewer" src="../../assets/pc_barocare/img_review5.png" alt="이용자 이미지">
                    <div class="cont">
                        <p>보호자분들의 만족도가 굉장히 높습니다.<br>
                            어르신 모시고 병원 방문 하던 일들이 없어지며<br>
                            효율이 증가합니다.</p>
                        <div class="info-reviewer">
                            <span class="reviewer">센터장</span><strong class="name">조OO님</strong>
                            <span class="info">43, 서울시 중랑구</span>
                        </div>
                    </div>
                </li>
                <li>
                    <img class="img-reviewer" src="../../assets/pc_barocare/img_review6.png" alt="이용자 이미지">
                    <div class="cont">
                        <p>신규 상담 오신 보호자분들께서 높은 관심을 <br>
                            보이십니다. 급한 설사, 변비도 진료 보고 약을 받아<br>
                            볼 수 있어 매우 만족합니다.</p>
                        <div class="info-reviewer">
                            <span class="reviewer">센터장</span><strong class="name">이OO님</strong>
                            <span class="info">50, 경기 성남시</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>

export default {
    name: 'review',
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped>
    .review{
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background: #fff;
    }
    .review .container{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        min-width: 960px;
        width: 100%;
        max-width: 1320px;
        min-height: 1060px;
        margin: 0 auto;
        padding: 180px 20px 90px;
        z-index: 1;
    }
    .section-header{
        width: 100%;
    }
    .section-header .title{
        font-family: 'Pretendard';
        font-style: normal;
        font-size: 44px;
        font-weight: 600;
        line-height: 1.6;
        color: #1A1A1A;
    }

    .card-list{
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 40px;
        /* width: 100%; */
        width: 1320px;
        margin-top: 45px;
        padding: 0;
        animation: fadeInUp1 2s;
    }
    .card-list li{
        display: flex;
        flex-direction: row;
        gap: 48px;
        max-width: 620px;
        min-height: 198px;
        width: calc(50% - 20px);
        padding: 34px 48px;
        background: #fff;
        border: 1px solid #CCC;
        border-radius: 10px;
    }
    .img-reviewer{
        width: 94px;
        height: 94px;
    }
    .cont{
        width: calc(100% - 142px);
        font-size: 18px;
        font-family: 'Pretendard';
        font-weight: 400;
        line-height: 1.7;
        color: #1A1A1A;
    }
    .cont p{
        margin-bottom: 8px;
    }
    .reviewer{
        font-weight: 600;
        color: #0082EC;
    }
    .name{
        padding:0 7px;
    }
    .info{
        position: relative;
        padding-left: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #999;
    }
    .info:before{
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        content: '';
        display: block;
        width: 1px;
        height: 12.5px;
        background: #999;
    }   
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare/Review.vue